import { createTheme } from "@mui/material";

export default createTheme({
  palette: {
    primary: { main: "#3887BE", contrastText: "#FFF" },
    secondary: { main: "#200E3A", contrastText: "#FFF" },
    success: {
      main: "#4BB543",
      contrastText: "#FFF",
      strong: "#6ABF4B",
      light: "#DBF9D0",
    },
    warning: { main: "#ff9800" },
    error: { main: "#B00020", contrastText: "#FFF" },
    dark: { main: "#455A64", neutralBlack: "#30343A" },
    secondaryGreen: { main: "#6EC0BE", hover: "#4AB0A6" },
    grey: { main: "#6F7B8A", neutral: "#5C606A" },
    lightBlue: { main: "#EBF5FF" },
    text: { secondary: "#200E3A", white: "#ffffff", black: "#232533" },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: 10,
          },
          "@supports (-webkit-touch-callout: none)": {
            fontSize: "16px"
          }
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 28,
          textTransform: "none",
        },
        customGreen: {
          textTransform: "none",
          backgroundColor: "#6EC0BE",
          color: "#FFF",
          "&:hover": {
            backgroundColor: "#4AB0A6",
          },
        },
        customWhite: {
          textTransform: "none",
          backgroundColor: "#ffffff",
          color: "#3887BE",
          "&:hover": {
            backgroundColor: "#f2f2f2",
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          cursor: "pointer",
          "& .MuiTableCell-root": {
            padding: "8px",
            lineHeight: "24px",
            fontSize: "14px",
            color: "#232533",
            fontFamily: "'Inter', sans-serif",
          },
          "&.MuiTableRow-hover:hover": {
            backgroundColor: "#EBF5FF",
          },
        },
      },
    },
  },
  typography: {
    fontFamily: `"Poppins", sans-serif`,
    fontSize: 15,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    body1: {
      fontSize: 14,
      fontWeight: 400,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#200E3A",
    },
    body2: {
      fontFamily: `"Inter", sans-serif`,
      fontSize: 14,
    },
    title: {
      fontFamily: `"Inter", sans-serif`,
      fontSize: 28,
      color: "#202224",
      fontWeight: 500,
    },
    titleSteps: {
      fontFamily: `"Poppins", sans-serif`,
      color: "#3887BE",
      fontWeight: 500,
    },
  },
});
